import type { CourseProgressRepository } from '@/domain/port/CourseProgressRepository';
import type { CourseProgress } from '@/domain/model/CourseProgress';

export class CourseProgressService {
  private readonly courseProgressRepository: CourseProgressRepository;

  constructor(courseProgressRepository: CourseProgressRepository) {
    this.courseProgressRepository = courseProgressRepository;
  }

  async getProgressForChapters(chapterIds: string[]): Promise<CourseProgress[]> {
    const progressByChapter = await Promise.all(
      chapterIds.map((chapterId) => this.courseProgressRepository.getChapterProgress(chapterId)),
    );
    return progressByChapter.flat();
  }

  saveCourseProgress(courseId: string, progressPercentage: number): Promise<CourseProgress> {
    return this.courseProgressRepository.saveCourseProgress(courseId, progressPercentage);
  }
}
